'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Tooltip = require('react-bootstrap/lib/Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Tooltip2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@sketchpixy/rubix/lib/Tooltip.js
 ** module id = ./node_modules/@sketchpixy/rubix/lib/Tooltip.js
 ** module chunks = 0
 **/